import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton } from '@mui/material';

interface ManagedLeadSectionEditButtonProps {
  /** Names what the pencil edits: the icon alone says nothing out loud. */
  label: string;
  onPress: () => void;
}

/**
 * The edit affordance of a managed lead detail box, in the corner the Mutui
 * detail puts it in, so the two products do not ask the operator to learn a
 * second layout. It is an affordance of the screen and not of the printed page,
 * which is what `no-print` says.
 */
const ManagedLeadSectionEditButton = ({
  label,
  onPress,
}: ManagedLeadSectionEditButtonProps) => (
  <IconButton onClick={onPress} className="no-print" aria-label={label}>
    <EditIcon sx={{ color: (theme) => theme.palette.secondary.dark }} />
  </IconButton>
);

export default ManagedLeadSectionEditButton;
